import Chart from 'react-apexcharts';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

export const ChartArea = ({ title = '', labels = [], data = [] }) => {
    const { t } = useTranslation();

    const { chartGroup } = useSelector((state) => ({
        chartGroup: state.dashboard.chartGroup,
    }));

    let xaxisTitle = '';

    switch (chartGroup) {
        case 'daily':
            xaxisTitle = 'Day';
            break;
        case 'weekly':
            xaxisTitle = 'Week';
            break;
        case 'monthly':
            xaxisTitle = 'Month';
            break;
        case 'yearly':
            xaxisTitle = 'Year';
            break;
    }
    const state = {
        options: {
            chart: {
                type: 'area',
                stacked: true,
                height: 440,
                zoom: {
                    enabled: false,
                },
                toolbar: false,
            },
            labels: labels,
            title: {
                text: title,
            },
            colors: ['#7f56d9', '#9a79e1', '#b89feb', '#c7b2f0', '#e5d8fa', '#f4ebff'],

            xaxis: {
                title: {
                    text: t(xaxisTitle),
                    style: {
                        color: '#667085',
                        cssClass: 'chartarea-xaxis-title',
                    },
                },
                type: 'datetime',
                labels: {
                    format: chartGroup === 'yearly' ? 'yy MMM' : chartGroup === 'daily' ? 'dd MMM' : 'MMM',
                    style: {
                        cssClass: 'chartarea-label',
                        colors: '#667085',
                    },
                    minHeight: 50,
                },
                axisBorder: {
                    show: false,
                },
                axisTicks: {
                    show: false,
                },
            },
            yaxis: {
                title: {
                    text: title,
                    style: {
                        color: '#667085',
                        cssClass: 'chartarea-xaxis-title',
                    },
                },
                labels: {
                    style: {
                        cssClass: 'chartarea-label',
                        colors: '#667085',
                    },
                },
            },
            dataLabels: {
                enabled: false,
            },
            stroke: {
                curve: 'smooth',
                width: 2,
            },
            tooltip: {
                x: {
                    format: 'dd/MM/yy',
                },
            },
            markers: {
                hover: {
                    size: 5,
                },
            },
            fill: {
                type: 'gradient',
                gradient: {
                    shade: 'dark',
                    type: 'vertical',
                    inverseColors: true,
                    opacityFrom: 0.3,
                    opacityTo: 0,
                },
            },
            grid: {
                borderColor: '#F2F4F7',
            },
        },
        series: [{ name: 'Total', data }],
    };

    return <Chart options={state.options} series={state.series} type="area" height={300} />;
};
